

import React, { useState } from 'react';
import { Navbar, Nav, NavDropdown, Container } from 'react-bootstrap';
import { Link } from "react-router-dom";

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [isSearchOpen] = useState(false);

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  return (
    <header>
      
      {/* Header Top */}
     <div className="header-top bgg-darkk pt-md-2">
  <div className="container">
    <div className="row justify-content-center justify-content-xl-between align-items-center">
      
      <div className="col-auto">
        <div className="header-top-contact">
          <ul className='anchor d-md-flex align-items-center'>

            <li className='px-md-5 fw-bold'>
              <a className='text-white' href="tel:+919689815477">
                <i className="fas fa-phone-volume text-white"></i> +91 9689815477
              </a>
            </li>

            <li className='px-md-5'>
              <a className='text-white' href="mailto:booking@shivaitravels.com">
                <i className="far fa-envelope text-white"></i>
                <span className='text-white fw-bold'> booking@shivaitravels.com</span>
              </a>
            </li>

            {/* Social Media Links */}
            <li className="d-flex gap-3">
              <a href="https://www.instagram.com/shivai_travels_6357/" target="_blank" rel="noreferrer">
                <i className="fab fa-instagram text-white"></i>
              </a>

              <a href="https://www.facebook.com/profile.php?id=61590124316940" target="_blank" rel="noreferrer">
                <i className="fab fa-facebook-f text-white"></i>
              </a>

              <a href="https://x.com/Shivaitravels" target="_blank" rel="noreferrer">
                <i className="fab fa-twitter text-white"></i>
              </a>

               <a href="https://in.pinterest.com/shivaitravels/" target="_blank" rel="noreferrer">
                <i className="fab fa-pinterest-p text-white"></i>
              </a>
            </li>

          </ul>
        </div>
      </div>

    </div>
  </div>
</div>


      {/* Main Navigation */}
      <div className="main-navigation">
        <Navbar expand="lg">
          <Container>

            <Link to="/">
              <img src="/images/logo.jpg" className='logoo' alt="logo" />
            </Link>

            <Navbar.Toggle aria-controls="main_nav" onClick={toggleNav}>
              <i className="fas fa-bars darkcolorr"></i>
            </Navbar.Toggle>

            <Navbar.Collapse id="main_nav" className={isNavOpen ? "show" : ""}>

              <Nav className="mx-auto">

                <Nav.Link as={Link} to="/" className='fw-bold nav-item'>
                  Home
                </Nav.Link>

                <NavDropdown title="About Us" id="about-us-dropdown" className='fw-bold'>

                  <NavDropdown.Item as={Link} to="/about-us" className='fw-bold nav-item'>
                    About Us
                  </NavDropdown.Item>

                  <NavDropdown.Item as={Link} to="/term-condition" className='fw-bold nav-item'>
                    Term & Condition
                  </NavDropdown.Item>

                  <NavDropdown.Item as={Link} to="/privacy-policy" className='fw-bold'>
                    Privacy Policy
                  </NavDropdown.Item>

                </NavDropdown>

                <Nav.Link as={Link} to="/services" className='fw-bold nav-item'>
                  Services
                </Nav.Link>

                <Nav.Link as={Link} to="/our-fleet" className='fw-bold nav-item'>
                  Our Fleet
                </Nav.Link>

                <Nav.Link as={Link} to="/packages" className='fw-bold nav-item'>
                  Packages
                </Nav.Link>
                  <Nav.Link as={Link} to="/our-network" className='fw-bold nav-item'>
                  Our Network
                </Nav.Link>

                <Nav.Link as={Link} to="/booking" className='fw-bold nav-item'>
                  Online Booking
                </Nav.Link>

                <Nav.Link as={Link} to="/gallery" className='fw-bold nav-item'>
                  Gallery
                </Nav.Link>

                
                <Nav.Link as={Link} to="/career" className='fw-bold nav-item'>
                  Career
                </Nav.Link>

                <NavDropdown title="Contact Us" id="contact-dropdown" className='fw-bold'>

                  <NavDropdown.Item as={Link} to="/contact-us" className='fw-bold nav-item'>
                    Contact Us
                  </NavDropdown.Item>

                  <NavDropdown.Item as={Link} to="/enquiry" className='fw-bold'>
                    Enquiry
                  </NavDropdown.Item>

                </NavDropdown>

              </Nav>

            </Navbar.Collapse>

          </Container>
        </Navbar>
      </div>


      {/* Search Area */}
      {isSearchOpen && (
        <div className="search-area">
          <form action="#">
            <div className="form-group">
              <input type="text" className="form-control" placeholder="Type Keyword..." />
              <button type="submit" className="search-icon-btn">
                <i className="far fa-search"></i>
              </button>
            </div>
          </form>
        </div>
      )}

    </header>
  );
};

export default Header;